module.exports = __webpack_public_path__ + "static/media/electric-station.a3c86ced.svg";